




































import { Vue, Component, Prop } from 'vue-property-decorator'
import SearchResultsList from 'components/presenter/search/SearchResultsList.vue'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import TrashEmpty from 'src/graphql/search/TrashEmpty.gql'

@Component({
  components: {
    SearchResultsList
  }
})
export default class PresenterTrashSearchResults extends Vue {
  clearing = false

  @Prop()
  readonly loading!: boolean

  @Prop()
  readonly query!: string

  @Prop()
  readonly found!: []

  async empty () {
    await confirm({
      title: this.$t('trash.confirmempty').toString()
    })
    this.clearing = true
    await api.mutate({
      query: TrashEmpty
    })
    this.$emit('empty')
    this.clearing = false
  }
}
